import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* createChargesForNextMounthGetPeriod(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_GET_PERIOD_REQUEST
    })
    
    const res = yield call(Http.get, `contract/${action.payload?.contractId}/check-next-period`);

    yield put({
      type: Constants.GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_GET_PERIOD_SUCCESS
    })

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res.data);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_GET_PERIOD_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchCreateChargesForNextMounthGetPeriod() {
  yield takeEvery(Constants.GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_GET_PERIOD_START, createChargesForNextMounthGetPeriod);
}
